import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getAllowedAttributes } from '../../props-filters';
import './PrimaryPanel.scss';

var PrimaryPanel = function PrimaryPanel(_ref) {
  var children = _ref.children,
      narrow = _ref.narrow,
      wrapable = _ref.wrapable,
      style = _ref.style,
      restProps = _objectWithoutProperties(_ref, ['children', 'narrow', 'wrapable', 'style']);

  return React.createElement(
    'div',
    _extends({ className: 'sb-header-primary-panel', style: style }, getAllowedAttributes(restProps)),
    React.createElement(
      'div',
      {
        className: cx('sb-header-primary-panel__content', {
          'sb-header-primary-panel__content--narrow': narrow,
          'sb-header-primary-panel__content--wrapable': wrapable
        })
      },
      children
    )
  );
};

PrimaryPanel.propTypes = {
  children: PropTypes.node,
  narrow: PropTypes.bool,
  wrapable: PropTypes.bool,
  style: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

export default PrimaryPanel;
//# sourceMappingURL=PrimaryPanel.js.map